var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminAppLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 32,
    viewBox: "0 0 119 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    fill: "url(#paint0_linear_13237_5588)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.78516 9.02148L12.832 11.3652C13.0078 11.5117 13.125 11.7168 13.125 11.9219V13.5039L16.3184 16.6973C17.168 16.2871 18.2227 16.4336 18.9258 17.1367L22.207 20.418C22.5879 20.7695 22.5879 21.3848 22.207 21.7363L20.332 23.6113C19.9805 23.9922 19.3652 23.9922 19.0137 23.6113L15.7324 20.3301C15.0293 19.627 14.8828 18.543 15.3223 17.6934L12.1289 14.5H10.5176C10.3125 14.5 10.1074 14.4121 9.96094 14.2363L7.61719 11.1895C7.41211 10.8965 7.44141 10.5156 7.70508 10.252L8.87695 9.08008C9.11133 8.8457 9.52148 8.81641 9.78516 9.02148ZM8.05664 20.5059L12.4219 16.1406L14.2383 17.957C14.0625 18.5723 14.0918 19.2461 14.3262 19.8613L10.8691 23.3184C10.5176 23.6699 9.99023 23.875 9.46289 23.875C8.37891 23.875 7.5 22.9961 7.5 21.9121C7.5 21.3848 7.70508 20.8574 8.05664 20.5059ZM22.5 13.0938C22.5 14.793 21.5039 16.2578 20.0684 16.9316L19.5996 16.4629C18.7793 15.6426 17.6074 15.3496 16.5527 15.6426L14.0625 13.123V13.0938C14.0625 10.7793 15.9375 8.875 18.2812 8.875C18.5742 8.875 18.8672 8.93359 19.1602 8.99219C19.4824 9.05078 19.5703 9.46094 19.3359 9.69531L17.4609 11.5703C17.373 11.6582 17.3438 11.7754 17.3438 11.8926V13.5918C17.3438 13.8262 17.5488 14.0605 17.8125 14.0605H19.4824C19.5996 14.0605 19.7168 14.002 19.8047 13.9141L21.6797 12.0391C21.9141 11.8047 22.3242 11.8926 22.3828 12.2148C22.4414 12.5078 22.5 12.8008 22.5 13.0938ZM9.14062 21.5312C9.14062 21.9414 9.43359 22.2344 9.84375 22.2344C10.2246 22.2344 10.5469 21.9414 10.5469 21.5312C10.5469 21.1504 10.2246 20.8281 9.84375 20.8281C9.43359 20.8281 9.14062 21.1504 9.14062 21.5312Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9443 21.122L42.4926 25.4498H40L46.5739 6.5498H48.7652L55.3391 25.4498H52.8465L51.3948 21.122H43.9443ZM50.6552 18.9855L47.6696 10.1107L44.6839 18.9855H50.6552Z",
    fill: "#2E3192"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7913 25.4498H58.7652V6.5498H64.7913C69.3565 6.5498 71.6391 9.37111 71.6391 15.0137V16.9859C71.6391 22.6285 69.3565 25.4498 64.7913 25.4498ZM61.1208 23.3133H64.7913C66.3252 23.3133 67.4574 22.8202 68.1878 21.8342C68.9182 20.8298 69.2834 19.2137 69.2834 16.9859V15.0137C69.2834 12.7859 68.9182 11.1789 68.1878 10.1928C67.4574 9.1885 66.3252 8.68633 64.7913 8.68633H61.1208V23.3133Z",
    fill: "#2E3192"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1715 6.5498H78.4724L84.1424 18.3281L89.785 6.5498H92.1132V25.4498H89.7576V11.5898L85.1558 21.5055H83.0467L78.5272 11.672V25.4498H76.1715V6.5498Z",
    fill: "#2E3192"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8641 6.5498H100.22V25.4498H97.8641V6.5498Z",
    fill: "#2E3192"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M116.445 20.985V6.5498H118.801V25.4498H116.5L108.338 11.1515V25.4498H105.982V6.5498H108.228L116.445 20.985Z",
    fill: "#2E3192"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13237_5588",
    x1: 28.6451,
    y1: 37.2613,
    x2: 42.7521,
    y2: 0.936215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE1E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3511,
    stopColor: "#EF4136"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6439,
    stopColor: "#F68B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.736,
    stopColor: "#F78E20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8284,
    stopColor: "#F89627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9206,
    stopColor: "#FAA535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9731,
    stopColor: "#FBB040"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminAppLogo);
export default __webpack_public_path__ + "static/media/admin-app-logo.abbcb58c2af94f72543a6e8c8fa16965.svg";
export { ForwardRef as ReactComponent };